
interface SpinnerProps {
  className?: string;
}

export default function Spinner({ className = 'h-5 w-5' }: SpinnerProps) {
  return (
    <div className={`animate-spin rounded-full border-2 border-slate-300 border-t-slate-600 ${className}`} />
  );
}
